function raw(value) {
  return String(value || '').trim().replace(/^v(?=\d)/i, '')
}

export function semver(value) {
  const valueRaw = raw(value)
  return valueRaw ? `v${valueRaw}` : ''
}

export function major(value) {
  const match = /^(\d+)(?:\.|$)/.exec(raw(value))
  return match ? `v${match[1]}` : ''
}

export function deploy(version) {
  const sha = String(version?.source_commit_sha || version?.sourceCommitSha || version?.commit_sha || version?.commitSha || version?.git_commit || version?.gitCommit || '').trim()
  return sha ? sha.slice(0, 8) : ''
}

export function summary(version, fallbackSemantic = '', fallbackBuild = 0) {
  const semantic = semver(version?.semantic_version || version?.semanticVersion || fallbackSemantic)
  const build = Math.max(0, Number(version?.version || fallbackBuild || 0))
  const source = deploy(version)
  return [
    semantic,
    build > 0 ? `build ${build}` : '',
    source ? `deploy ${source}` : '',
  ].filter(Boolean).join(' · ')
}
